"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/RoomSidebar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _ui = require('web/services/ui');

const currentYear = (new Date()).getFullYear()







const RoomSidebar = ({ roomName, roomLink, onRoomLinkCopy }) => {
  const linkTextRef = _react.useRef(null)

  const handleRoomLinkClick = async () => {
    await onRoomLinkCopy()
    // Selecting a missing node rejects, as in JS.
    return _ui.selectTextNode.call(void 0, linkTextRef.current)
  }

  return (
    _react2.default.createElement('div', { className: "video-call--room-sidebar--wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
      , _react2.default.createElement('div', { className: "video-call--room-sidebar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}
        , _react2.default.createElement('div', { className: "video-call--room-sidebar--logo-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
          , _react2.default.createElement('img', {
            className: "video-call--room-sidebar--logo",
            src: "/assets/icons/video/bloom-logo-white.svg",
            alt: "BloomText", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}
          )
        )
        , _react2.default.createElement('div', { className: "video-call--room-sidebar--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
          , _react2.default.createElement('h3', { className: "video-call--room-sidebar--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}, "Video Meeting"

          )
          , _react2.default.createElement('h1', { className: "video-call--room-sidebar--room-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
            ,  roomName 
          )
          ,  roomLink &&
            _react2.default.createElement(_react2.default.Fragment, null
              , _react2.default.createElement('a', {
                ref: linkTextRef,
                onClick: handleRoomLinkClick,
                className: "video-call--room-sidebar--room-link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}

                , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 45}},  roomLink )
              )
              , _react2.default.createElement('div', { className: "video-call--room-sidebar--btns-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}
                , _react2.default.createElement('a', { className: "video-call--room-sidebar--btn", onClick: onRoomLinkCopy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
                  , _react2.default.createElement('img', { src: "/assets/icons/video/copy-white.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}} ), "Copy link"

                )
              )
            )
          
        )
        , _react2.default.createElement('div', { className: "video-call--room-sidebar--footer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
          , _react2.default.createElement('span', { className: "video-call--room-sidebar--footer-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}, "© "
             ,  currentYear , " BloomAPI Inc."
          )
        )
      )
    )
  )
}

exports. default = RoomSidebar
